<div class="district-container pt-20">
  <div *ngIf="district" class="cardList">
    <ng-container>
      <!-- Top row: Header + Placeholder (left) | Essential Data (right) -->
      <div class="top-row cardListItem full-width">
        <!-- Left column -->
        <div class="left-column">
          <mat-card class="header-card">
            <mat-card-content>
              <app-district-header-card
                [districtName]="district.districtName"
                [isFinal]="isFinal"
                [lastUpdate]="lastUpdate"
                [countProgress]="getCountProgress()"
              ></app-district-header-card>
            </mat-card-content>
          </mat-card>

          <!-- Jump links card (hidden on mobile) -->
          <mat-card class="jump-links-card" *ngIf="!electionService.isMobile">
            <mat-card-content>
              <div class="jump-links">
                <a class="jump-link" (click)="scrollTo('winning-candidate')">
                  <span class="jump-icon">▼</span> Winning candidate
                </a>
                <a class="jump-link" (click)="scrollTo('first-preferences')">
                  <span class="jump-icon">▼</span> Votes won – first preferences
                </a>
                <a class="jump-link" (click)="scrollTo('after-preferences')">
                  <span class="jump-icon">▼</span> Votes won – Two Candidate Preferred
                </a>
                <a class="jump-link" (click)="scrollTo('first-pref-by-place')">
                  <span class="jump-icon">▼</span> First preferences by voting
                  centre & vote type
                </a>
                <a class="jump-link" (click)="scrollTo('tcp-by-place')">
                  <span class="jump-icon">▼</span> Two candidate preferred by
                  voting centre & vote type
                </a>
                <a
                  class="jump-link"
                  (click)="scrollTo('distribution-preferences')"
                >
                  <span class="jump-icon">▼</span> Distribution of preferences
                </a>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <!-- Right column (hidden on mobile) -->
        <mat-card class="essential-card" *ngIf="!electionService.isMobile">
          <mat-card-content>
            <app-district-essential-data-card
              [districtName]="district.districtName"
            ></app-district-essential-data-card>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-card id="winning-candidate" class="cardListItem full-width">
        <mat-card-header>
          <mat-card-title> Successful Candidate </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <app-district-successful-candidate
            [districtName]="district.districtName"
          ></app-district-successful-candidate>
        </mat-card-content>
      </mat-card>
      <mat-card id="first-preferences" class="cardListItem">
        <mat-card-header>
          <mat-card-title>Votes won – first preferences</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <first-preference-table></first-preference-table>
        </mat-card-content>
      </mat-card>
      <mat-card id="after-preferences" class="cardListItem">
        <mat-card-header>
          <mat-card-title>Votes won – Two Candidate Preferred</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <app-parties-currently-leading-chart></app-parties-currently-leading-chart>
        </mat-card-content>
      </mat-card>
      <mat-card id="first-pref-by-place" class="cardListItem full-width">
        <mat-card-header class="align-center">
          <mat-card-title
            >First preferences by voting centre & vote type</mat-card-title
          >
        </mat-card-header>
        <mat-card-content class="align-center">
          <first-preference-by-place></first-preference-by-place>
        </mat-card-content>
      </mat-card>
      <mat-card id="tcp-by-place" class="cardListItem full-width">
        <mat-card-header class="align-center">
          <mat-card-title>
            Two Candidate Preferred by voting centre & vote type
          </mat-card-title>
        </mat-card-header>
        <mat-card-content class="align-center">
          <two-cp-by-place-and-vote-type></two-cp-by-place-and-vote-type>
        </mat-card-content>
      </mat-card>
      
      <!-- Distribution of preferences - data-driven rendering -->
      <mat-card 
        id="distribution-preferences" 
        class="cardListItem full-width"
        *ngIf="hasDistributionData()"
      >
        <mat-card-header class="align-center">
          <mat-card-title>Distribution of preferences</mat-card-title>
        </mat-card-header>
        <mat-card-content class="align-center">
          <distribution-of-preferences></distribution-of-preferences>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </div>
</div>
